export default "__VITE_ASSET__CVak0qRI__";